import React, { useState } from 'react';
import Button from 'shared/components/Button';
import Input from 'shared/components/Input';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Mail } from 'lucide-react';
import { URLS } from 'configs';
import './Auth.scss';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [email, setEmail] = useState('');
  const [fetch, setFetch] = useState(false);
  const [error, setError] = useState();

  const onFormSubmit = async e => {
    setFetch(true);
    e.preventDefault();
    try {
      await Auth.forgotPassword(email);
      history.push('/auth/reset', { email });
    } catch (err) {
      setError(err.message);
      setFetch(false);
    }
  };

  return (
    <>
      <div className='auth-welcome'>
        <h1 className='auth-welcome__title'>{t('title_forgot_pass', 'Forgot your password?')}</h1>
        <p className='auth-welcome__subtitle'>
          {t('sub_title_forgot_pass', "Tell us your email address, and we'll get you back on track in no time.")}
        </p>
      </div>

      <div className='auth-card'>
        <form onSubmit={onFormSubmit}>
          <div className='auth-form-group'>
            <label className='auth-label'>
              <Mail className='auth-icon' size={16} />
              {t('ph_email', 'Email')} *
            </label>
            <Input
              type='email'
              name='email'
              onChange={({ target }) => setEmail(target.value)}
              value={email}
              placeholder={t('signin_email_placeholder', 'your@email.com')}
              required
              className='mb-0'
              inputClassName='auth-input-field'
            />
          </div>
          {error && <div className='auth-error'>{error}</div>}
          <div className='auth-submit-wrapper'>
            <Button
              type='submit'
              withLoading={fetch}
              disabled={fetch}
              className='btn-primary btn-block auth-submit-btn'
            >
              {t('btn_reset_pass', 'Reset password')}
            </Button>
          </div>
          <p className='auth-footer-text'>
            <a href={URLS.CONTACT} className='auth-link-bold'>
              {t('contact_us', 'Contact us')}
            </a>
          </p>
        </form>
      </div>
    </>
  );
};

export default ForgotPassword;
